module.exports = __webpack_public_path__ + "static/plans-672e3392008624ead7059787795e63f5.svg";